import React, { Component } from 'react'
import { withIdentity } from '#src/containers/Identity'
import { Forbidden, Unauthorized } from '#src/components/Errors'
import intersection from 'lodash/intersection'
import hoistNonReactStatic from 'hoist-non-react-statics'
import { WithIdentityProps } from './withIdentity'
import { User } from '../../typings'

function isAllowed(user: User, allowedPermissions: string[]) {
  // @ts-ignore: Permissions DO exist on the users object for free, not in the gql file
  return user && intersection(user.permissions, allowedPermissions).length > 0
}

function getDisplayName(WrappedComponent: React.ComponentType<any>) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}

export default function withPermission<P>(allowedPermissions: string | string[]) {
  // Returns a HOC scoped to the appropriate role(s)
  return (WrappedComponent: React.ComponentType<P>) => {
    class WithPermission extends Component<WithIdentityProps & P> {
      public static displayName = `WithPermission(${getDisplayName(WrappedComponent)})`

      public render() {
        const { myself, ...rest } = this.props
        let allowed = false

        // Normalize allowed roles to an Array
        if (myself) {
          if (typeof allowedPermissions === 'string') {
            allowed = isAllowed(myself.user, [allowedPermissions])
          } else if (Array.isArray(allowedPermissions)) {
            allowed = isAllowed(myself.user, allowedPermissions)
          }
        } else {
          return <Unauthorized />
        }

        if (allowed) {
          // @ts-ignore: This nested dec doesn't this this.props is referencing correctly
          return <WrappedComponent {...rest} />
        } else {
          return <Forbidden />
        }
      }
    }

    return hoistNonReactStatic(withIdentity<P>(WithPermission), WrappedComponent)
  }
}
